export default {
  "create-success": {
    EN: "Successfully created Product Group",
  },
  "create-failure": {
    EN: "Failed to create Product Group. Please try again later.",
  },
  "update-success": {
    EN: "Successfully updated Product Group",
  },
  "update-failure": {
    EN: "Failed to update Product Group. Please try again later.",
  },
  "delete-success": {
    EN: "Successfully deleted Product Group",
  },
  "delete-failure": {
    EN: "Failed to delete Product Group. Please try again later.",
  },
};
